import { render, staticRenderFns } from "./notificationsWrapper.vue?vue&type=template&id=1c504af5&scoped=true&lang=html&"
import script from "./notificationsWrapper.vue?vue&type=script&lang=js&"
export * from "./notificationsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./notificationsWrapper.vue?vue&type=style&index=0&id=1c504af5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c504af5",
  null
  
)

export default component.exports